import { Eye } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { TCoverTone } from './coverHelpers'
import s from './webCover.module.css'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  authorName?: string | null
  authorAvatar?: string | null
  viewsCount?: number
  tone: TCoverTone
}

/** Плашка автора карточки веба: на светлой обложке — тёмный текст. */
export const WebCoverBadge = ({ authorName, authorAvatar, viewsCount = 0, tone }: Props) => {
  const m = useMessages(messages)
  return (
    <div className={cn(s.badge, tone === 'light' ? s.toneLight : null)}>
      {authorAvatar ? (
        <img src={authorAvatar} alt="" className={s.avatar} />
      ) : (
        <div className={cn(s.avatar, s.avatarPlaceholder)} />
      )}
      <span className={cn(s.badgeText, s.name)}>{authorName ?? m.author}</span>
      <span className={cn(s.badgeText, s.separator)} aria-hidden>
        •
      </span>
      <span className={s.viewsGroup}>
        <Eye className={cn(s.badgeText, s.eye)} aria-hidden />
        <span className={s.badgeText}>{viewsCount}</span>
      </span>
    </div>
  )
}
